<h1 mat-dialog-title>Escala de coma de Glasgow (ECG)</h1>
<div mat-dialog-content>
  <div class="modal-body text-center">
    <h4 class="modal-subtitulo">{{glasgowScale.title}}</h4>
    <ul class="ul-opcoes text-left">
      @for (item of glasgowScale.body; track item) {
        <li><a (click)="clickSelect(item.value)"><span>{{item.value}}</span>{{item.label}}</a></li>
      }
    </ul>
  </div>
</div>